<template>
  <div class="spec-wrap" ref="wrap" @click="click">
    <span class="spec-title">Specification</span>

    <div class="right">
      <FlavorPieChart v-if="pieChartWidth" :series="series" :legend="legend" :width="pieChartWidth" class="flavor-pie-chart"/>
    </div>

    <van-image :src="require('@/assets/icons/v2/ic_home_right_arrow.png')" width="16" height="16" class="right-icon"/>

  </div>
</template>

<script>
import FlavorPieChart from "@/components/FlavorPieChart.vue";

export default {
  name: "Specification",
  components: { FlavorPieChart },
  props: {
    seriesData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      pieChartWidth: 0,
      series: {
        center: ["75%", "50%"], // 将饼图移到最右边
        radius: ["70%", "90%"],
        data: this.seriesData
      },
      legend: {
        orient: "vertical",
        left: "10", // 将图例左侧居中
        top: "20",
        align: "left",
        icon: "circle",
        itemWidth: 5, // 设置圆点宽度
        itemHeight: 5 // 设置圆点高度
      }
    };
  },
  watch: {
    seriesData(val) {
      this.series = {
        center: ["70%", "50%"], // 将饼图移到最右边
        radius: ["70%", "90%"],
        data: val
      };
    }
  },
  methods: {
    click() {
      this.$emit('click')
    }
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      this.pieChartWidth = `${this.$refs.wrap.clientWidth}px`;
    });
  }
};
</script>


<style scoped lang="less">
.spec-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;

  .spec-title {
    font-size: 14px;
    font-weight: normal;
  }

  .left {
    display: flex;
    flex-direction: column;

  }

  .right {
    flex: 1;
    margin-top: -20px;
  }
}

.right-icon {
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
}

.flavor-pie-chart {
  flex: 1;
  height: 115px
}


// iPhone13
@media only screen and (min-device-width: 390px)  and (-webkit-device-pixel-ratio: 3)  {

  .flavor-pie-chart {
    flex: 1;
    height: 115px
  }

}

// iPhoneXSMax
@media only screen and (min-device-width: 414px)  and (-webkit-device-pixel-ratio: 3)  {

  .flavor-pie-chart {
    flex: 1;
    height: 115px
  }

}

// iPhone13 pro max
@media only screen and (min-device-width: 428px)  and (-webkit-device-pixel-ratio: 3)  {

  .flavor-pie-chart {
    flex: 1;
    height: 145px
  }

}
</style>